import React from 'react';
import ReactDOM from 'react-dom/client';
import '@sagano/admin/styles/index.css';
import '@sagano/admin/i18n';
import App from '@sagano/admin/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
